import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapWaypoint } from '../../../core/models';
import { AppState, ShowRequest } from '../../../core';


@Component({
  templateUrl: './waypoint-marker-popup.component.html',
  styleUrls: ['./waypoint-marker-popup.component.scss'],
  viewProviders: [ CommonModule]
})
export class WaypointMarkerPopupComponent implements OnInit {

  @Input() pt : MapWaypoint;
  @Input() selectedPt : MapWaypoint;
  @Input() pathId : string;
  @Input() testPoints : MapWaypoint[]
  @Input() bShowSelectButton : boolean
  @Input() setSelectedPointFn : ( pt : MapWaypoint ) => void
  @Input() deleteScoutPointFn : ( pt : MapWaypoint ) => void
  @Input() allowEditMode : boolean = true
  @Input() changeGuard : (current: MapWaypoint, acceptFn: ()=>void) => void = (c,a) => a()
  @Input() showRefDataFn : ( pt : MapWaypoint ) => void
  @Input() locked : boolean

  strLat : string
  strLng : string

  constructor( protected appState: AppState ) {

  }
  
  ngOnInit() {
    this.strLat = this.pt.latitude ? Number(this.pt.latitude).toFixed(6) : ''
    this.strLng = this.pt.longitude ? Number(this.pt.longitude).toFixed(6) : ''
  }


  openExternalUrl(url:string) {
    if ( this.appState.isElectron() ) {
      const shell = window.require('electron').shell;
      shell?.openExternal(url)
    } else {
      window.open( url, `${this.pathId} Waypoint ${this.pt.name}` );
    }
  }
  
  onShowGoogleMapsPoint(lat:string,lng:string) {
    this.openExternalUrl(`https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},21z`)
  }

  onSelectPoint = () => {
    console.log('onSelectPoint' + this.pt.name)
    this.setSelectedPointFn(this.pt)
  }

  onShowRefData = () => {
    this.showRefDataFn(this.pt)    
  }

  onShowPoint = ( pointId : string ) => {
    this.appState.showView.next( new ShowRequest('tab','point', pointId) )
  }

}